import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const ServicesSection = () => {
  const services = [
    {
      title: "Vedic Astrology",
      description:
        "Comprehensive birth chart analysis, planetary positions, and life path guidance through Vedic wisdom. The Vedic astrology calculator generates your Kundli which could be used as a guiding tool to make conscious choices in life.",
      image: "/images/vedic_astrology.png",
      features: ["Birth Chart Analysis", "Career Guidance", "Relationship Compatibility"],
    },
    //Making Birth Chart/Kundali
    {
      title: "Making Birth Chart/Kundali",
      description:
        "A Kundli depicts life wherein multiple aspects are divided into 12 houses. Based on these, astrologers predict past, present, and future depending on karmas. It's a graphical representation of planets, houses, stars and their effects on life.",
      image: "/images/kundali_analysis.png",
      features: ["Making Birth Chart/Kundali", "Kundali Analysis", "Yearly Forecast", "Dasha Calculation", "Dasha Analysis", "Gemstone Prediction", "Remedies"],
    },
    //end Making Birth Chart/Kundali

    //Match Making

    {
      title: "Match Making",
      description:
        "Match making uses Kundli comparison to ensure compatibility between partners. It analyzes multiple aspects and their influence on married life, ensuring harmony and prosperity in the relationship.",
      image: "/images/match_making.png",
      features: ["Horoscope Match", "Guna Milan", "Match Prediction", "Remedies if Any"],
    },


    //end Match Making

    //Numerology
    {
      title: "Numerology Prediction",
      description:
        "Numerology, or the science of numbers, studies the vibrational energy of numbers to predict the future based on  your Birthdate,Mobile Number &  Name to reveal Personality traits and life events.",
      image: "/images/numerology.png",
      features: ["Destiny Number", "Lucky Number", "Life Analysis", "Relationship Compatibility"],
    },
    //end Numerology
    //Name Correction
    {
      title: "Name Correction & Name Analysis",
      description:
        "Name correction through numerology helps align your name's vibrations with positive energies. A correctly spelled name can bring prosperity, success, and good fortune by harmonizing with your birth numbers & Name.",
      image: "/images/name_correction.png",
      features: ["Lucky Name", "Career Growth", "Business Growth",],
    },


    //End Name Correction
    //New born naming
    {
      title: "New Born Baby Naming",
      description:
        "Choose the Most Auspicious Name that aligns your .Little one though Numerology Guidance ensuring Balance,Strength & Success in Life.",
      image: "/images/new baby naming.png",
      features: ["Based on Birth Date & Time", "Name Suggestions for Prosperity & Peace "],
    },

    //end New born naming

    //Modern Astrology

    {
      title: "Modern Astrology",
      description:
        "Blending ancient wisdom with modern insights for comprehensive guidance. Get clear picture of your past, present, and future through contemporary astrological methods combined with Vedic + Nadi-Nakashtra + KP Astrology Techniques.",
      image: "https://images.unsplash.com/photo-1684770460215-8787483a4b3a?w=600&q=80",
      features: ["Western + Vedic", "Career Mapping - JOB - BUSINESS- FINANCE- RELATIONSHIP", "Education", "Marriage", "Travel", "Child Birth", "Health"],
    },

    //End Modern Astrology


    //Event Prediction Based on Prashna
    {
      title: "Event Prediction Based on Prashna Shastra",
      description: "",
      image: "/images/effective_remedies.png",
      features: ["JOB", "BUSINESS", "FINANCE", "EDUCATION", "MARRIAGE", "FOREIGN TRAVEL"],
    },

    //end Event Prediction Based on Prashna


    //HOlistic healing solution

    {
      title: "Holistic Healing Solution",
      description:
        "Very effective Healing solutions for Prevention and management of life Problems.These time tested solutions include vedic switch words,Lal Kitab remedies,Energy circles,Rudraksha Solutions, Crystals,Mantras and specific rituals tailored to individual horoscopes for maximum benefits.",
      image: "/images/Holistic.jpeg",
      features: ["Mantras", "Yantra Guidance", "Ritual Recommendations"],
    },






    //end HOlistic healing solution


    //Palm Reading
    {
      title: "Palm Reading",
      description:
        "Palmistry or Chiromancy is the practice of reading one's palm to obtain insights about life. With roots in India and China, it is believed that successful implementation helps determine luck and various aspects of human life.",
      image: "https://images.pexels.com/photos/7182586/pexels-photo-7182586.jpeg?w=600&q=80",
      features: ["Life Line Analysis", "Heart Line Reading", "Fate Predictions"],
    },
    {
      title: "Vastu Shastra",
      description:
        "Vastu Shastra is the traditional science of architecture describing the significance of direction, layout, and alignment. It plays an important role in enriching our lives by helping us build homes, offices, and temples harmoniously.",
      image: "/images/vastu_shastra.png",
      features: ["Home Vastu", "Office Vastu", "Directional Corrections"],
    },






  ];

  return (
    <section id="services" className="py-20 lg:py-32 bg-secondary/30 relative">
      {/* Decorative Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 -left-20 w-[400px] h-[400px] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 -right-20 w-[400px] h-[400px] bg-amber/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-primary font-medium mb-2">Our Services</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Our <span className="text-gradient-gold">Spiritual Services</span>
          </h2>
          <div className="section-divider mx-auto mb-6" />
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Discover the ancient wisdom of Vedic astrology and spiritual healing through our comprehensive range of services
          </p>
        </div>

        {/* Services List */}
        <div className="space-y-20">
          {services.map((service, index) => (
            <div
              key={index}
              className={`grid lg:grid-cols-2 gap-8 lg:gap-16 items-center ${index % 2 === 1 ? "lg:flex-row-reverse" : ""
                }`}
            >
              {/* Image */}
              <div
                className={`relative ${index % 2 === 1 ? "lg:order-2" : ""}`}
              >
                <div className="relative rounded-2xl overflow-hidden group">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-[300px] lg:h-[400px] object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background/60 via-transparent to-transparent" />
                </div>
                {/* Decorative Line */}
                <div
                  className={`hidden lg:block absolute top-1/2 -translate-y-1/2 w-20 h-0.5 bg-gradient-to-r from-primary to-amber ${index % 2 === 1 ? "-left-10" : "-right-10"
                    }`}
                />
              </div>

              {/* Content */}
              <div className={index % 2 === 1 ? "lg:order-1" : ""}>
                <h3 className="font-display text-2xl lg:text-3xl font-bold text-primary mb-2">
                  {service.title}
                </h3>
                <div className="section-divider mb-6" />
                <p className="text-muted-foreground leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* Features */}
                <ul className="space-y-2 mb-8">
                  {service.features.map((feature, fIndex) => (
                    <li
                      key={fIndex}
                      className="flex items-center gap-2 text-foreground"
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-primary" />
                      {feature}
                    </li>
                  ))}
                </ul>

                <a
                  href={`https://wa.me/919870511379?text=Namaste%20Pandit%20ji%2C%20I%20would%20like%20to%20book%20a%20consultation%20for%20${encodeURIComponent(
                    service.title
                  )}.`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button
                    variant="outline"
                    className="border-primary/50 text-primary hover:bg-primary hover:text-primary-foreground gap-2 rounded-full"
                  >
                    Book Consultation
                    <ArrowRight className="w-4 h-4" />
                  </Button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
